/**
 * アコーディオンの初期化と制御を行うクラス
 * @example
 * // 初期化
 * const accordion = new AccordionController();
 * // すべて開く
 * accordion.openAll();
 * // すべて閉じる
 * accordion.closeAll();
 * // アンマウント（クリーンアップ）
 * accordion.unmount();
 */
export class AccordionController {
    constructor() {
        // アコーディオンの状態を保持する配列
        this.accordions = [];
        // クリックイベントのリスナーを保存する配列
        this.listeners = [];

        // メソッドのthisを事前にバインド
        this.unmount = this.unmount.bind(this);
        this.toggleAccordion = this.toggleAccordion.bind(this);
        this.openAll = this.openAll.bind(this);
        this.closeAll = this.closeAll.bind(this);

        this.init();
    }

    /**
     * アコーディオンの初期化
     * @private
     */
    init() {
        const accBtns = document.querySelectorAll(".acc__txt");

        accBtns.forEach((btn) => {
            if (window.innerWidth > 1024 && btn.classList.contains("sponly")) {
                return;
            }

            const ans = btn.previousElementSibling || btn.nextElementSibling;
            if (!ans) return;

            ans.style.height = "auto";
            const originalHeight = ans.scrollHeight;
            ans.style.height = "0";

            this.accordions.push({
                element: ans,
                height: originalHeight,
                isOpen: false,
            });

            const clickHandler = () =>
                this.toggleAccordion(btn, ans, originalHeight);
            this.listeners.push({
                element: btn,
                handler: clickHandler,
                type: "click",
            });
            btn.addEventListener("click", clickHandler);
        });
    }

    /**
     * アンマウント（クリーンアップ）処理
     * イベントリスナーの削除とデータのクリア
     * @public
     */
    unmount() {
        try {
            // すべてのイベントリスナーを削除
            this.listeners.forEach(({ element, handler, type }) => {
                if (element && element.removeEventListener) {
                    element.removeEventListener(type, handler);
                }
            });

            // アコーディオンの状態をリセット
            // this.accordions.forEach((acc) => {
            //     if (acc.element && acc.element.style) {
            //         acc.element.style.height = "";
            //         if (acc.element.parentElement) {
            //             acc.element.parentElement.classList.remove("is-on");
            //         }
            //     }
            // });

            // 配列をクリア
            this.listeners = [];
            this.accordions = [];
        } catch (error) {
            console.warn("アンマウント中にエラーが発生しました:", error);
        }
    }

    /**
     * 個別のアコーディオンの開閉
     * @private
     * @param {HTMLElement} btn - クリックされたボタン要素
     * @param {HTMLElement} ans - 開閉する内容要素
     * @param {number} height - コンテンツの実際の高さ
     */
    toggleAccordion(btn, ans, height) {
        const parent = btn.parentElement;
        if (!parent) return;

        const isOpen = parent.classList.toggle("is-on");
        const accState = this.accordions.find((acc) => acc.element === ans);

        if (accState) {
            accState.isOpen = isOpen;
        }

        ans.style.height = isOpen ? `${height}px` : "0px";

        // scrollbackクラスがある場合は、閉じる時にスクロール位置を調整
        if (!isOpen && btn.classList.contains("scrollback")) {
            window.scrollTo({
                top: window.scrollY - height,
                behavior: "smooth",
            });
        }
    }

    /**
     * すべてのアコーディオンを開く
     * @public
     */
    openAll() {
        this.accordions.forEach((acc) => {
            if (!acc.isOpen) {
                acc.element.style.height = `${acc.height}px`;
                acc.element.parentElement?.classList.add("is-on");
                acc.isOpen = true;
            }
        });
    }

    /**
     * すべてのアコーディオンを閉じる
     * @public
     */
    closeAll() {
        this.accordions.forEach((acc) => {
            if (acc.isOpen) {
                acc.element.style.height = "0px";
                acc.element.parentElement?.classList.remove("is-on");
                acc.isOpen = false;
            }
        });
    }
}

// 使用例
// const accordion = new AccordionController();

// アンマウントする場合（例：ページ遷移時やコンポーネントのアンマウント時）
// accordion.unmount();
